/**
 * Parâmetros da lista de tickets de UMA mesa (Lista e Kanban). Puro de
 * propósito: a guarda da spec 066 (apps/api/src/shared/ticket-list-params.test.ts)
 * confere que "Meus tickets" chega às três consultas da tela.
 *
 * "Meus tickets" (spec 066, D1) é o responsável = quem está logado. Não é o
 * `scope: 'mine'` da spec 018, que inclui os sem responsável.
 *
 * `TicketsListParams` mora aqui, e não em tickets-queries, para a guarda da API
 * importar este arquivo sem levar junto o cliente HTTP do web.
 */

export interface TicketsListParams {
  /** spec 018: visão de trabalho (o predicado dos indicadores do Hoje) */
  view?: 'mine' | 'needs_reply' | 'at_risk' | 'unassigned' | 'waiting_client' | 'all';
  /** spec 018: `mine` = meus OU sem responsável */
  scope?: 'mine' | 'team';
  /** spec 018: situações efetivas, separadas por vírgula */
  situations?: string;
  desk_ids?: number[];
  stage_ids?: number[];
  client_ids?: number[];
  responsible_ids?: number[];
  /** v11: filtro por grupo de tickets. */
  group_id?: number;
  status?: 'open' | 'closed' | 'canceled' | 'all';
  search?: string;
  limit?: number;
  offset?: number;
  sort?: 'created_at' | 'updated_at' | 'activity' | 'awaiting';
  order?: 'asc' | 'desc';
}

export interface DeskListFilter {
  desk: number | undefined;
  group?: number;
  q: string;
  /** id de quem está logado quando "Meus tickets" está ligado; senão undefined */
  responsibleId?: number;
}

const base = ({ desk, group, q, responsibleId }: DeskListFilter): TicketsListParams => ({
  desk_ids: desk !== undefined ? [desk] : undefined,
  group_id: group,
  search: q || undefined,
  responsible_ids: responsibleId !== undefined ? [responsibleId] : undefined,
});

/** Abertos da mesa, agrupados por estágio (Lista) ou em colunas (Kanban). */
export function openDeskListParams(filter: DeskListFilter, limit: number): TicketsListParams {
  return { ...base(filter), status: 'open', limit, offset: 0 };
}

/** Fechados, cancelados ou todos, paginados. */
export function flatDeskListParams(
  filter: DeskListFilter,
  status: 'closed' | 'canceled' | 'all',
  limit: number,
  offset: number
): TicketsListParams {
  return { ...base(filter), status, limit, offset };
}
